import { ZipApi } from '../../lib/ZipApi';
import { directoryStore } from '../DirectoryStore';
import { ObjectDefinition } from '../../types/DataSyncItem';
import { DataSyncObjectsStore } from './DataSyncObjectsStore';

export default class DataSyncHubAppObjectsStore extends DataSyncObjectsStore {

  protected async fetchSourceObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId) {
      return [];
    }

    const trackerId = directoryStore.trackerId;
    const instanceId = this.instanceId as string;

    const sources = await ZipApi.listAppSources(trackerId, instanceId);

    return await Promise.all(
      sources.map(async (source) => {
        const schema = await ZipApi.listHubAppSourceSchema(
          trackerId,
          instanceId,
          source.name
        );

        return schema ? {
          object_name: source.name,
          fields: schema.fields
        } : null;
      })
    ).then((results) => results.filter(Boolean) as ObjectDefinition[]);
  }

  protected async fetchDestinationObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId) {
      return [];
    }

    const trackerId = directoryStore.trackerId as string;
    const instanceId = this.instanceId as string;

    const destinations = await ZipApi.listAppDestinations(
      trackerId,
      instanceId
    );
    return Promise.all(
      destinations.map(async (destination) => {
        const schema = await ZipApi.listHubAppDestinationSchema(
          trackerId,
          instanceId,
          destination
        );
        return schema
          ? ({
              object_name: destination,
              fields: schema.fields,
            } as ObjectDefinition)
          : null;
      })
    ).then((schemas) => schemas.filter(Boolean) as ObjectDefinition[]);
  }

  protected handleFetchError(error: any): void {
    super.handleFetchError({
      intent: 'danger',
      message: 'Unable to fetch source app schema, please try again later.'
    });
  }
}
